import home from "./api/home";
export default {
  home
};



// WEBPACK FOOTER //
// ./src/http/index.js